import React from 'react';
import MainHeader from './MainHeader';
import VideoBanner from './home/VideoBanner';
import PainBanner from './home/PainBanner';
import PromiseBanner from './home/PromiseBanner';
import Footer from './Footer';
import AbilityBanner from './home/AbilityBanner';
import ExerciseBanner from './home/ExerciseBanner';
import FeedbackBanner from './home/FeedbackBanner';
import StrengthHeaderBanner from './home/StrengthHeaderBanner';
import StrengthAbilityBanner from './home/StrengthAbilityBanner';
import StrengthEventBanner from './home/StrengthEventBanner';
import StrengthDataBanner from './home/StrengthDataBanner';
import ContactHeaderBanner from './home/ContactHeaderBanner';
import ContactBanner from './home/ContactBanner';


export default function Home() {
  return <>
    <MainHeader />
    <VideoBanner />
    <PainBanner />
    <ExerciseBanner />
    <FeedbackBanner />
    {/* <AbilityBanner /> */}
    <StrengthHeaderBanner />
    <StrengthAbilityBanner />
    <StrengthEventBanner />
    <StrengthDataBanner />
    <ContactHeaderBanner />
    <ContactBanner />
    {/* <PromiseBanner /> */}
    <Footer />
  </>
}
